/**
 * Chart palette.
 *
 * NOT the UI accent colours: those were tested and failed as a data palette
 * (violet vs blue are indistinguishable even with normal vision, green vs amber
 * fails colour-blind separation). These slots are validated for lightness,
 * chroma, colour-blind separation and contrast on a white card surface.
 *
 * Assign slots in fixed order and never cycle them: a 4th series folds into
 * "Other" or becomes its own chart.
 */
export const CHART_SERIES = Object.freeze([
  '#2a78d6', // 1 blue
  '#eb6834', // 2 orange
  '#1baf7a', // 3 aqua  - below 3:1 on white, so always ship visible labels
]);

export const seriesColor = (index) => CHART_SERIES[index % CHART_SERIES.length];

/** Pipeline stage owner -> colour, so the hand-off is visible in the funnel. */
export const OWNER_COLORS = Object.freeze({
  TELEPRO: CHART_SERIES[0],
  COMMERCIAL: CHART_SERIES[1],
  ADMIN: CHART_SERIES[2],
  null: '#8a8f98',
});
